<template>
  <Transition>
    <div class="preloader"></div>
  </Transition>
</template>
